type Props = {
  src: string;
};

const AutomakerLogo = ({ src }: Props) => {
  return (
    <div>
      <img className='me-2 avatar-2xl' src={src} alt='Automaker Logo' />
    </div>
  );
};

export default AutomakerLogo;
